import { create } from "zustand"

type HeaderVisibilityStore = {
  hidden: boolean
  setHidden(data: boolean): void
  height: number
  setHeight(data: number): void
}

export const useHeaderVisibility = create<HeaderVisibilityStore>((set) => ({
  hidden: false,
  setHidden: (data) => set({ hidden: data }),
  height: 0,
  setHeight: (data) => set({ height: data }),
}))
